import { render, staticRenderFns } from "./ImportGamesModal.vue?vue&type=template&id=162ce9fa"
import script from "./ImportGamesModal.vue?vue&type=script&lang=js"
export * from "./ImportGamesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports